export default __webpack_public_path__ + "static/media/Metropolis-Light.5813789e.otf";